export function validateRequiredFields(values, fields, errors) {
    fields.forEach((field) => {
        if (!values[field]) {
            errors[field] = 'Required field';
        }
    });
    return errors;
}


export function validateEmail(values, field, errors) {
    if (!isValidEmail(values[field])) {
        errors[field] = 'msg_error_invalid_email';
    }
    return errors;
}


export function isValidEmail(value) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(value);
}



// WEBPACK FOOTER //
// ./src/js/utils/form.js